// This js file controls the behaviour of the jump-to link ins every single page.
VP = window.VP || {};

(function( $ ) {
	var CLASSNAME = {
		arrowsEnabled: 'vp-quicklinks--arrows-enabled',
		arrowDisabledSingle: 'disabled',
		isScrolled: 'is-scrolled',
	};

	VP.quicklinks = {
		enabled:false,

		init: function () {
			var _this = this;

			_this.quicklinks    = $( '.vp-quicklinks' );

			this.$element = $('.vp-quicklinks');

			if ( !this.$element.length ) { return; }

			_this.enabled = true;

			this.$linkList = this.$element.find( '.vp-quicklinks__slider' );
			this.$dummy = this.$element.next('.vp-quicklinks__dummy');
			this.$items = this.$element.find('.vp-quicklinks__slide a');
			this.$prevArrow = this.$element.find('.slick-prev');
			this.$nextArrow = this.$element.find('.slick-next');
			this.scrollAmount = 0.5; // slider width ratio
			this.quickLink_positions = [];
			this.jumpLink_elements = [];
			this.quickLink_current_index = null;
			this.quicklinksHeight = _this.quicklinks.height();
			this.headerHeight = $( '.vp-header' ).height();
			this.scrollPosPadding = 100;

			this.isIE11 = (!!window.MSInputMethodContext && !!document.documentMode);
			this.isScrolling = true;  // prevents hash changes during automated scroll
			this.isDocked = false;


			VP.documentEvents.onResize( this.onResize.bind( this ), true );

			_this.setupActiveLinkOnScroll();
			_this.dockQuicklinks();
			_this.slideTo();
			_this.windowResizer();
			_this.desktopLinkSwipeable();

			this.onResize();

			// Attach to element
			this.$element.data('quicklinks', this);

			// update metrics when initial setup is complete
			setTimeout(function() {
				_this.updateMetrics();
				_this.isScrolling = false;
				_this.hashCheck();
			}, 500);
		},

		hashCheck: function() {
			// console.log("[quicklinks] hashCheck");
			var _this = this;
			if (window.location.hash != "") {
				hashlink = window.location.hash;
				hashlinkalt = hashlink.replace("#","#quicklinks-reference_");
				$qlink = $(".vp-quicklinks a[href='"+hashlink+"'],.vp-quicklinks a[href='"+hashlinkalt+"']");
				if ($qlink.length == 1) {
					// console.log("[quicklinks] foundhash")
					_this.updateMetrics();
					_this.isScrolling = true;
					VP.reveal.updatePosition();

					// console.log("1: Click for Hash");
					$qlink.trigger("click");

					// if not docked on load, trigger second click to reposition correctly
					if (!_this.isDocked) {
						setTimeout(function() {
							// console.log("2: Click for no dock");
							$qlink.trigger("click");
						},800);
					}

				}
			}
		},

		// Enables/disables slick carousel according to breakpoint
		onResize: function () {
			var _this = this;
			var breakpoint = VP.breakpoint.currentBreakpoint;

			this.updateMetrics();

			this.$dummy.height( this.height );

			if ( breakpoint === 'small' ) {
				this.disableArrows();
				this.$linkList.on('scroll', this.isScrolled.bind(this));
				return;
			}

			// If content is more than the width (scrollable), enable arrows
			// Else, disable
			
			var _buffer = 2; // for rounding issues, small pixels
			// console.log("[QUICKLINKS]",this.sliderScrollWidth, this.sliderWidth + _buffer);
			if ( this.sliderScrollWidth > this.sliderWidth + _buffer) {
				if ( ! this.arrowsEnabled ) { this.enableArrows(); }
			} else {
				if ( this.arrowsEnabled ) { this.disableArrows(); }
			}

			this.updateArrowStates();
			this.updateQuickLinkMetrics();
		},

		// Saves calculations
		updateMetrics: function () {
			var _this = this;
			if ( !_this.enabled ) {
				return;
			}
			// console.log("[quicklinks] updateMetrics");

			this.height = this.$element.outerHeight();
			this.sliderWidth = this.$linkList.outerWidth();
			this.sliderScrollWidth = this.$linkList[0].scrollWidth;
			this.maxScroll = this.sliderScrollWidth - this.sliderWidth;
			this.quicklinksHeight = this.quicklinks.height();
			this.headerHeight = $( '.vp-header' ).height();

			this.updateQuickLinkMetrics();
			this.quickLink_positions[ this.quickLink_positions.length - 1 ] = null;
		},

		updateQuickLinkMetrics: function() {
			var _this = this;
			// update the positions of the quick link items.
			this.$items.each(function ( index, ele ) {
				_this.quickLink_positions[index] = $( _this.jumpLink_elements[index] ).offset().top;
			});
		},

		// Enables arrows
		enableArrows: function () {
			var _this = this;
			this.arrowsEnabled = true;
			this.$element.addClass( CLASSNAME.arrowsEnabled );
			this.$prevArrow.off('click').on('click', function (e) {
				e.preventDefault();
				if ( ! $(this).hasClass( CLASSNAME.arrowDisabledSingle ) ) {
					_this.scrollContents( false );
				}
			});
			this.$nextArrow.off('click').on('click', function (e) {
				e.preventDefault();
				if ( ! $(this).hasClass( CLASSNAME.arrowDisabledSingle ) ) {
					_this.scrollContents( true );
				}
			});
			this.$linkList.on('scroll', _this.onListScroll.bind(this));
		},

		// Disables arrows
		disableArrows: function () {
			this.arrowsEnabled = false;
			this.$element.removeClass( CLASSNAME.arrowsEnabled );
			this.$linkList.off('scroll');
			this.$prevArrow.off('click').unbind('click');
			this.$nextArrow.off('click').unbind('click');
		},

		// Apply arrow states according to current scroll position
		updateArrowStates: function ( targetScroll ) {
			targetScroll = targetScroll || 0;

			this.$prevArrow.toggleClass( CLASSNAME.arrowDisabledSingle , targetScroll <= 0 );
			this.$nextArrow.toggleClass( CLASSNAME.arrowDisabledSingle , targetScroll >= this.maxScroll );
		},

		//Swipe nav left or right to scroll the quicklink nav on desktop.
		desktopLinkSwipeable: function() {
			var _this = this;
			var dragging = false;
			var clickOnPageX = null;
			// amount of pixel the user have to drag the mouse before the quicklink starts to slide
			var dragThreshold = 10;

			$(document.body).on("mousemove", function(e) {
				if (dragging) {
					e.preventDefault();
					var xPos = clickOnPageX - e.pageX;

					if ( (e.pageX - dragThreshold) > clickOnPageX ) {
						_this.scrollContents( false );
					} else if ( (e.pageX + dragThreshold) < clickOnPageX ) {
						_this.scrollContents( true );
					}
				}
			});

			_this.$linkList.on("mousedown", function (e) {
				dragging = true;
				clickOnPageX = e.pageX;
			});

			$(window).on("mouseup", function (e) {
				dragging = false;
			});
		},

		// Scrolls the links list
		// @param {Boolean} forwards - If true, scrolls forward. Else, backwards
		scrollContents: function ( forwards ) {
			// console.log("------- scrollContents");
			var currentScroll = this.$linkList[0].scrollLeft;
			var scrollIncrement = this.sliderWidth * this.scrollAmount * ( forwards ? 1 : -1 );
			var targetScroll = currentScroll + scrollIncrement;
			targetScroll = targetScroll >= this.maxScroll ? this.maxScroll : targetScroll;

			// Ensure updated scrollWidth
			this.sliderScrollWidth = this.$linkList[0].scrollWidth;

			// Let's see if the remaining scroll will be less than scrollAmount
			// If it is, include it on the animated scroll now (scroll to beginning/end)
			var remainingAfterScroll = forwards ? this.maxScroll - targetScroll : targetScroll;
			if ( remainingAfterScroll / this.sliderWidth < this.scrollAmount ) {
				targetScroll = forwards ? this.maxScroll : 0;
			}

			this.$linkList.stop().animate({ scrollLeft: targetScroll }, 300, 'swing');
			this.updateArrowStates( targetScroll );
			this.isScrolled();
		},

		onListScroll: function () {
			var currentListScroll = this.$linkList[0].scrollLeft;
			this.updateArrowStates( currentListScroll );
			this.isScrolled();
		},

		// This will add class when scroll amount is more than 0
		isScrolled: function () {
			var targetScroll = this.$linkList[0].scrollLeft;
			this.$element.toggleClass(CLASSNAME.isScrolled, targetScroll > 0);
		},

		// This will control the smooth scroll transition when jumping from one link to another
		slideTo: function() {
			var _this = this;

			var _link             = $( '.vp-quicklinks__slide a' );
			var _headerHeight     = this.headerHeight;
			var _quicklinksHeight = this.quicklinksHeight;
			var _padding 		  		= _headerHeight + _quicklinksHeight;

			_link.click( function(e) {

				e.preventDefault();
				var _referenceModule  = $( this ).attr( 'href' ).substr( 1 );
				var hashlink = _referenceModule.replace("quicklinks-reference_","");
				history.replaceState("", document.title, "#"+hashlink);

				_this.isScrolling = true;
				//console.log("set scrolling");
				//console.log("scrolling to: " + $( '#' + _referenceModule ).offset().top);
				$( 'html, body' ).stop(true,false).animate({
					scrollTop: ( $( '#' + _referenceModule ).offset().top - _padding ) + 'px'
				}, 1000, function() {
					_this.isScrolling = false;
					_this.updateQuickLinkMetrics();
				});
			});
		},

		// This function will fire everytime a resize event is done.
		// This will re-compute the scroll position of the jump-to link.
		windowResizer: function() {
			var _this = this;
			var resizeTimer;

			if ( VP.breakpoint.currentBreakpoint !== 'small' && this.enabled ) { return; }

			$( window ).on( 'resize', function(e) {
				clearTimeout( resizeTimer );
				resizeTimer = setTimeout( function() {
					_this.dockQuicklinks();
				}, 250 );
			});
		},

		// This will control when and where the quicklinks bar will be fixed on scroll event.
		dockQuicklinks: function() {
			var _this = this;

			// Undock it first to get the offset
			_this.quicklinks.removeClass( 'vp-quicklinks--docked' );
			$( 'body' ).removeClass('vp-ql-docked');


			_this.dockable = _this.quicklinks.find('.quicklinks');
			_this.quicklinksPos = _this.dockable.offset().top;
			_this.headerHeight  = $( '.vp-header' ).height();

			_this.checkScrollPosition();

			$( window ).scroll( function() {
				_this.checkScrollPosition();
				_this.getLastScrollElementHeight();
			});
		},

		checkScrollPosition: function() {
			var _this = this;
			var _scrollTop = $( window ).scrollTop() + _this.headerHeight;
			var _scrollTop_offset = _scrollTop + this.quicklinksHeight;

			if(  _scrollTop > _this.quicklinksPos ) {
				_this.quicklinks.addClass( 'vp-quicklinks--docked' );
				$( 'body' ).addClass('vp-ql-docked');
				_this.isDocked = true;
			} else {
				_this.quicklinks.removeClass( 'vp-quicklinks--docked' );
				$( 'body' ).removeClass('vp-ql-docked');
				_this.isDocked = false;
			}


			/*
			 * Add active state for jumplink nav by jumplink element positions on the page.
			 */
			var _currentPos = _this.quickLink_positions.map(function(value,i) {
				var _scroll_pos = value - (_scrollTop_offset + _this.scrollPosPadding);
				if (_scroll_pos <= 0 ) {
					return _scroll_pos;
				} else {
					return Number.NEGATIVE_INFINITY;
				}
			});

			var _index_active_jumplink = _currentPos.indexOf( Math.max.apply( null, _currentPos ) );

			//console.log("::: INDEX JUMP LINK" + _index_active_jumplink);
			//console.log("::: CURRENT INDEX" + _this.quickLink_current_index);

			if ( _index_active_jumplink !== _this.quickLink_current_index ) {

				// if new item exists, change it
				if ($( _this.$items[_index_active_jumplink] ).length) {
					_this.$items.filter('.active').removeClass('active');
					$( _this.$items[_index_active_jumplink] ).addClass('active')
					_this.quickLink_current_index =  _index_active_jumplink;
					_this.checkItemVisibility();
				}
			}

			// update hash on scroll
			if ( _index_active_jumplink !== _this.quickLink_current_index ) {
				var isactive = false;
				if (_this.quicklinks.hasClass( 'vp-quicklinks--docked' )) {
					$activelink = _this.$items.filter('.active');
					if ($activelink.length == 1) {
						isactive = true;
						activehref = $activelink.attr("href");
						var hashlink = activehref.replace("quicklinks-reference_","");
						//console.log(hashlink);
						if (window.location.hash != hashlink) {
							_this.pushState("", document.title, hashlink);
						}
					}
				}


				if ( !isactive ) {
					if (window.location.hash != "") {
						//console.log("update no link");
						var windowLocationPath = window.location.pathname;
						// This removes undefined that IE11 adds to the pathname which causes page to not reload.
						if (_this.isIE11) {
							windowLocationPath = windowLocationPath.replace(/undefined/i,'');
						}
						_this.pushState("", document.title, windowLocationPath + VP.helpers.utmParam);
					}
				}
			}

		},

		pushState: function(params, name, url) {
			var _this = this;
			if ( _this.isScrolling ) { return; }

			// disable for conflict on story tracker
			if (typeof(VP.storyTracker) == "object" && VP.storyTracker.enabled) { 
				// console.log("disable update for ST"); return; 
			}
			//console.log("push state");
			window.clearTimeout( _this.updateHistoryState );
			// Set a timeout to run after scrolling ends
			_this.updateHistoryState = setTimeout(function() {
				// Run the callback
				history.replaceState( params, name, url );
			}, 40);
		},

		setupActiveLinkOnScroll: function() {
			var _this = this;

			/* Check if the quicklink reference element is on the page,
			 * if not remove the link from the quicklink nav.
			 * This fixes the Booking module quicklink error when admin entered an invalid ID
			 * causing the Booking module does not appear on the page.
			 */
			_this.$items.each(function ( index, ele ) {
				var _quickLink_pos = $( ele.getAttribute('href') ).offset();
				if (!_quickLink_pos) {
					ele.closest('div').remove();
				}
			});

			this.$items = this.$element.find('.vp-quicklinks__slide a');

			// Get the page position of the jumplink list item.
			_this.$items.each(function ( index, ele ) {
				_this.jumpLink_elements.push( $( ele.getAttribute('href') ) );
				_this.quickLink_positions.push( $( ele.getAttribute('href') ).offset().top );
			});

			// Push a null value since some modules do not yet have the proper height on page load.
			// Will get the height value on first page scroll.
			_this.quickLink_positions.push( null );
		},

		getLastScrollElementHeight: function() {
			var _this = this;
			/* get the height of the last jumplink element here since some modules because
			 * they have to run some JS do not get the proper height on page load
			 * Using height of the last active element to off all active states
			 * on the quicklink once user scrolls pass all the elements.
			 */
			if (_this.quickLink_positions[ _this.quickLink_positions.length - 1 ] === null) {
				_this.updateQuickLinkMetrics();
				_this.quickLink_positions[ _this.quickLink_positions.length - 1 ] = ( _this.quickLink_positions[ _this.quickLink_positions.length - 2 ] + $( this.$items[this.$items.length-1].getAttribute('href') ).height() + _this.scrollPosPadding );
			}
		},

		// Check if the active item is still viewable
		checkItemVisibility: function() {
			var _this = this;
			var $el = _this.$items.filter('.active');

			if( $el.length === 0 ) {
				return;
			}

			var _activeLeft = $el.offset().left;
			var _activeRight = $el.offset().left + $el.outerWidth();
			var _left = _this.$linkList.offset().left;
			var _right = _this.$linkList.offset().left + _this.$linkList.outerWidth() - 30;

			if( _activeLeft < _left ) {
				_this.scrollContents( false );
			} else if( _activeRight > _right ) {
				_this.scrollContents( true );
			}
		},
	};
})(jQuery);
